export default __webpack_public_path__ + "static/media/menu.6d44f731.webp";